import RouteHelper from "../../helpers/RouteHelper"
import { Article, ArticleCollection, News, PublicLocale } from "../../types"
import ERoute from "../ERoute"

export const articleLink = (article: Article) => {
  return RouteHelper.process(ERoute.PATH_ARTICLE, { id: article.id })
}

export const newsLink = (news: News) => {
  return RouteHelper.process(ERoute.PATH_NEWS, { id: news.id })
}

export const collectionLink = (collection: ArticleCollection) => {
  return RouteHelper.process(ERoute.PATH_HELP_COLLECTION, { id: collection.id })
}